<template>
    <v-app>
        <portal-sysbar :show-customer="false"></portal-sysbar>
        <div class="main-content">
            <portal-aside></portal-aside>
            <portal-title title="Notifications"></portal-title>
            <portal-breadcumb></portal-breadcumb>
            <div class="content">
                <div class="justify-end">
                    <v-btn small color="primary" @click="openModal">
                        <v-icon>mdi-plus</v-icon> New
                    </v-btn>
                </div>


                <v-data-table :items="data" :headers="headers" :loading="loading" loading-text="Loading... Please wait">
                    <template v-slot:item.actions="{ item }">
                        <v-icon small class="mr-2">
                            mdi-pencil {{ item.id }}
                        </v-icon>
                        <v-icon small>
                            mdi-delete
                        </v-icon>
                    </template>
                </v-data-table>

                <!-- dialog form-->
                <v-dialog v-model="createModal" width="400">
                    <v-card>
                        <v-card-title>
                            Créer un utilisateur
                        </v-card-title>
                        <v-card-text>
                            <v-form ref="form" v-model="formValid">
                                <v-text-field label="Name" required :rules="rules.name"
                                    v-model="formData.name"></v-text-field>
                                <v-text-field label="Code" required :rules="rules.name"
                                    v-model="formData.code"></v-text-field>
                                <v-textarea label="description" v-model="formData.description" rows="2"></v-textarea>

                            </v-form>

                            <div class="validation">
                                <v-btn color="secondary" @click="resetFormFields" :disabled="!formValid">
                                    Reset
                                </v-btn>
                                <v-btn color="primary" @click="sendForm" :disabled="!formValid">
                                    Submit
                                </v-btn>

                                <div v-if="loadingCreation" class="loading-creation">
                                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                    in progress
                                </div>
                                <div v-if="successCreation" class="success-creation">
                                    <v-icon color="green">mdi-check</v-icon> Success
                                </div>
                                <div v-if="errorCreation" class="error-creation">
                                    <v-icon color="red">mdi-cancel</v-icon> {{ errorCreation }}
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </div>
        </div>
    </v-app>
</template>

<script>
import PortalSysbar from "@/components/PortalSysbar";
import PortalAside from "@/components/PortalAside";
import PortalTitle from "@/components/PortalTitle";
import PortalBreadcumb from "@/components/PortalBreadcumb";
import CoreService from "@/services/CoreService";


export default {
    components: {
        PortalSysbar,
        PortalAside,
        PortalTitle,
        PortalBreadcumb,
    },
    data() {
        return {
            headers: [
                { text: "Name", value: "name" },
                { text: "Code", value: "code" },
                { text: "Description", value: "description" },
                { text: "Actions", value: "actions" }
            ],
            data: [],
            fonctions: [],
            formData: { user: {} },
            loading: true,
            createModal: false,
            loadingCreation: false,
            successCreation: false,
            errorCreation: null,
            formValid: false,
            rules: {
                name: [
                    v => !!v || 'Champ requis',
                ],
                description: [
                    v => !!v || 'Champ requis'
                ]
            }
        }
    },
    mounted() {
        this.loadData()
    },
    methods: {

        loadData() {
            CoreService.findAllNotifications().then(({ data }) => {
                this.data = data;
                this.loading = false;
            });
        },
        resetFormFields() {
            this.$refs.form.reset();
        },
        resetForm() {
            this.loadingCreation = false;
            this.successCreation = false;
            this.errorCreation = null;
        },

        openModal() {
            this.$refs.userForm.reset();
            this.successCreation = false;
            this.createModal = true;
        },

        sendForm() {
            this.$refs.form.validate();
            this.loadingCreation = true;
            this.errorCreation = null;
            CoreService.createNotification(this.formData).then(() => {
                this.loadingCreation = false;
                this.successCreation = true;
                this.createModal = false;
                this.loadData()
            }).catch((error) => {
                this.loadingCreation = false;
                this.errorCreation = error.response.data;
            })
        },
    },
    watch: {
        createModal(newVal) {
            if (!newVal) {
                this.resetForm();
            }
            return newVal;
        }
    },
    computed: {

    },
}
</script>

<style scoped>
.justify-end {
    display: flex;
    justify-content: end;
}

.validation {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
}

.loading-creation {
    color: blue;
}

.success-creation {
    color: green;
}

.error-creation {
    color: red;
}
</style>